<template>
  <v-container fluid pt-0 mt-0>
    <v-row>
      <v-col cols="12" md="12" sm="12" xs="12">
        <v-card>
          <v-toolbar flat color="#2A3B4D" dark class="d-print-none">
            <v-toolbar flat color="#2A3B4D" dark>
              <v-toolbar-title class=".body-2">Postulacion y monitoreo</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-toolbar>
          <v-tabs vertical>
            <!-- Titulos -->
            <v-tab active-class="grey lighten-5" @click="limpiar">Postulacion</v-tab>
            <v-tab active-class="grey lighten-5" @click="limpiar">Monitoreo</v-tab>
            <!-- Postulacion -->
            <v-tab-item>
              <v-container fluid class="grey lighten-5">
                <v-row dense>
                  <v-col cols="12" md="5" sm="5" xs="12" dense>
                    <v-card class="pa-2" outlined tile>
                      <span class="font-weight-bold">Postulacion</span>
                      <v-row dense class="pa-3">
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-autocomplete
                            v-model="requerimiento_id"
                            :items="requerimientos"
                            label="Requerimiento"
                            @change="selectPerfilByRequerimiento"
                            class="pt-0"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-autocomplete
                            v-model="perfil_id"
                            :items="perfiles"
                            label="Perfil"
                            class="pt-0"
                            @change="MostarPerfil"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-autocomplete
                            v-model="area_id"
                            :items="areas"
                            label="Empresa - Area"
                            readonly
                            class="pt-0"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-autocomplete
                            v-model="individuo_id"
                            :items="individuos"
                            label="Postulante"
                            class="pt-0"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-autocomplete
                            v-model="trabajador_id"
                            :items="trabajadores"
                            label="Trabajador"
                            class="pt-0"
                          ></v-autocomplete>
                        </v-col>
                        <!--
                         <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="postulacion_fechainicio"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="postulacion_fechainicio"
                                label="Fecha inicio"
                                prepend-icon="event"
                                v-on="on"
                                class="pt-0"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="postulacion_fechainicio" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.menu.save(postulacion_fechainicio)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                         <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="postulacion_fechafin"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="postulacion_fechafin"
                                label="Fecha fin"
                                prepend-icon="event"
                                v-on="on"
                                class="pt-0"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="postulacion_fechafin" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.menu.save(postulacion_fechafin)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>-->
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-textarea
                            label="Observaciones"
                            v-model="postulacion_observaciones"
                            :rows="2"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 text-sm-left">
                          <v-chip
                            class="ma-2"
                            color="primary"
                            outlined
                            pill
                            @click="limpiarPostulacion"
                          >Nuevo</v-chip>
                          <v-chip class="ma-2" color="primary" pill @click="savePostulacion">Guardar</v-chip>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="7" sm="7" xs="12" dense>
                    <v-card class="pa-2" outlined tile>
                      <span class="font-weight-bold">Data</span>
                      <v-row dense class="pa-3">
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-data-table
                            :headers="headerpostulacion"
                            :items="postulaciones"
                            :search="searchpostulacion"
                            class="elevation-1"
                          >
                            <template v-slot:top>
                              <v-toolbar flat color="white">
                                <v-text-field
                                  v-model="searchpostulacion"
                                  append-icon="mdi-magnify"
                                  label="Busqueda"
                                  single-line
                                  hide-details
                                ></v-text-field>
                              </v-toolbar>
                              <v-divider></v-divider>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-icon
                                color="primary"
                                @click="editItemPostulacion(item)"
                              >mdi-square-edit-outline</v-icon>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <!-- Monitoreo -->
            <v-tab-item>
              <v-container fluid class="grey lighten-5">
                <v-row dense>
                  <v-col cols="12" md="12" sm="12" xs="12" dense>
                    <v-card class="pa-2" outlined tile id="print">
                      <span class="font-weight-bold text-center">Monitoreo</span>
                      <v-row dense class="pa-3 pb-0"></v-row>
                      <v-row dense class="pa-3 pt-0 pb-0">
                        <v-col cols="12" md="4" sm="4" xs="12" dense>
                          <v-autocomplete
                            v-model="requerimiento_id"
                            :items="requerimientos"
                            label="Nro de requerimiento"
                            class="pt-0"
                            @change="selectPerfilByRequerimiento"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" sm="4" xs="12" dense>
                          <v-autocomplete
                            v-model="perfil_id"
                            :items="perfiles"
                            label="Perfil"
                            class="pt-0"
                            @change="selectIndividuoByDetalle"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" sm="4" xs="12" dense>
                          <v-autocomplete
                            v-model="individuo_id"
                            :items="individuos"
                            label="Persona"
                            class="pt-0"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-stepper v-model="e6" vertical>
                            <v-stepper-step :complete="e6 > 1" step="1">
                              Evaluacion postuante
                              <small>Entrevistas y evaluacion tecnica a cargo de DHO, la contratista o el area usuaria</small>
                            </v-stepper-step>

                            <v-stepper-content step="1">
                              <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
                              <v-btn color="primary" @click="e6 = 2">Continue</v-btn>
                              <v-btn text>Cancel</v-btn>
                            </v-stepper-content>

                            <v-stepper-step
                              :complete="e6 > 2"
                              step="2"
                            >Presentacion de documentos
                            <small>Entrega de CV documentado, certificados de antecedentes penales y policiales</small>
                            </v-stepper-step>

                            <v-stepper-content step="2">
                              <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
                              <v-btn color="primary" @click="e6 = 3">Continue</v-btn>
                              <v-btn text>Cancel</v-btn>
                            </v-stepper-content>

                            <v-stepper-step
                              :complete="e6 > 3"
                              step="3"
                            >Examen medico
                            <small>Examen medico ocupacional (EMO)</small>
                            </v-stepper-step>

                            <v-stepper-content step="3">
                              <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
                              <v-btn color="primary" @click="e6 = 4">Continue</v-btn>
                              <v-btn text>Cancel</v-btn>
                            </v-stepper-content>

                            <v-stepper-step step="4">
                              Induccion
                              <small>Induccion general y especializada</small>
                              </v-stepper-step>
                            <v-stepper-content step="4">
                              <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
                              <v-btn color="primary" @click="e6 = 5">Continue</v-btn>
                              <v-btn text>Cancel</v-btn>
                            </v-stepper-content>

                            <v-stepper-step step="5">
                              Contrato
                              <small>Inicio de vinculo laboral</small>
                              </v-stepper-step>
                            <v-stepper-content step="5">
                              <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
                              <v-btn color="primary" @click="e6 = 1">Continue</v-btn>
                              <v-btn text>Cancel</v-btn>
                            </v-stepper-content>
                          </v-stepper>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data: () => ({
    e6: 1,
    menu: false,
    menu2: false,
    /*Area*/
    areas: [],
    area_id: "",
    searchareas: "",
    /*Perfil*/
    searchperfil: "",
    perfiles: [],
    perfil_id: "",
    /* Requerimiento */
    searchrequerimiento: "",
    requerimiento_id: "",
    requerimientos: [],
    /*DetalleRequerimiento*/
    searchdetallerequerimiento: "",
    detallereq_id: "",
    detallereqs: [],

    /*Postulante*/
    individuos: [],
    individuo_id: "",
    searchindividuo: "",

    /*Relacionista*/
    trabajadores: [],
    trabajador_id: "",
    searchtrabajador: "",

    /*Postulacion*/
    postulacion_id: "",
    postulacion_fechainicio: new Date().toISOString().substr(0, 10),
    postulacion_fechafin: new Date().toISOString().substr(0, 10),
    postulacion_etapaactual: "",
    postulacion_observaciones: "",
    editedIndexpostulacion: -1,
    postulacion_condicion: true,
    searchpostulacion: "",
    postulaciones: [],
    headerpostulacion: [
      { text: "Nombre", value: "individuo" },
      // { text: "Perfil", value: "perfil" },
      // { text: "Requerimiento", value: "requerimiento" },
      { text: "Actions", value: "actions", sortable: false }
    ],

    /*Etapa postulacion*/
    etapapostulacion_id: "",
    etapapostulacion_abreviatura: "",
    etapapostulacion_orden: "",
    etapapostulacion_etapa: "",
    etapapostulacion_estado: "",
    etapapostulacion_fechainicio: "",
    etapapostulacion_fechaactualizacion: "",
    etapapostulacion_observaciones: "",

    valida: 0,
    validamensaje: [],
    menu2: null
  }),

  created() {
    this.listarPostulacion();
    this.selectRequerimiento();
    this.selectPerfil();
    this.selectArea();
    this.selectIndividuo();
    this.selectTrabajador();
    this.listarDetalleRequerimiento();
  },

  methods: {
    /*Limpiar */
    limpiar() {
      let me = this;
      console.log("Entra a limpiar");
      me.area_id = "";
      me.perfil_id = "";
      me.requerimiento_id = "";
      me.perfilid2 = "";
      /*me.requerimientoid2="";
      me.perfildenominacion2="";
      me.detallereqcantidad2="";
      me.perfil_tipo2="";
      me.detallereqmotivo2="";
      me.perfilfunciones2="";
      me.experiencias2=[];
      me.educaciones2=[];
      me.conocimientos2=[];
      me.beneficios2=[];*/
    },

    /*Trabajador*/
    selectTrabajador() {
      let me = this;
      var Array = [];
      axios
        .get("api/Empleados/Select")
        .then(function(response) {
          Array = response.data;
          Array.map(function(x) {
            me.trabajadores.push({ text: x.empleado, value: x.idempleado });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    /*Area*/
    selectArea() {
      let me = this;
      var Array = [];
      axios
        .get("api/Areas/Listar")
        .then(function(response) {
          Array = response.data;
          Array.map(function(x) {
            me.areas.push({ text: x.empresa, value: x.idarea });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    /*Perfil*/
    selectPerfil() {
      let me = this;
      var Array = [];
      axios
        .get("api/Perfiles/Select/?areaid=" + me.areaid)
        .then(function(response) {
          Array = response.data;
          Array.map(function(x) {
            me.perfiles.push({ text: x.denominacion, value: x.idperfil });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    selectPerfilByRequerimiento() {
      let me = this;
      var Array = [];
      me.perfiles = [];
      console.log("Entra a ID requerimiento" + me.requerimientoid2);
      axios
        .get(
          "api/DetallesRequerimientos/GetDetallesByRequerimiento/?requerimientoid=" +
            me.requerimiento_id
        )
        .then(function(response) {
          Array = response.data;
          console.log("Datos:" + JSON.stringify(Array));
          Array.map(function(x) {
            me.perfiles.push({ text: x.perfil, value: x.idperfil });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    MostarPerfil() {
      let me = this;
      var Array = [];
      axios
        .get("api/Perfiles/Mostrar/" + me.perfil_id)
        .then(function(response) {
          console.log("Entra a mostrar perfil " + response.data.denominacion);
          me.area_id = response.data.idarea;
          me.MostarDetalleRequerimiento();
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    /*Individuo*/
    selectIndividuoByDetalle() {
      let me = this;
      var Array = [];
      me.perfiles = [];
      console.log("Entra a ID requerimiento" + me.requerimientoid2);
      axios
        .get(
          "api/DetallesRequerimientos/GetDetallesByRequerimiento/?requerimientoid=" +
            me.requerimiento_id
        )
        .then(function(response) {
          Array = response.data;
          console.log("Datos:" + JSON.stringify(Array));
          Array.map(function(x) {
            me.perfiles.push({ text: x.perfil, value: x.idperfil });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    selectIndividuo() {
      let me = this;
      var Array = [];
      axios
        .get("api/Individuos/Select")
        .then(function(response) {
          Array = response.data;
          Array.map(function(x) {
            me.individuos.push({
              text: x.nombrecompleto,
              value: x.idindividuo
            });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    /*Requerimiento */
    selectRequerimiento() {
      let me = this;
      var Array = [];
      axios
        .get("api/Requerimientos/Select")
        .then(function(response) {
          Array = response.data;
          Array.map(function(x) {
            me.requerimientos.push({
              text: x.denominacion,
              value: x.idrequerimiento
            });
          });
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    /*Detalle requerimiento*/

    MostarDetalleRequerimiento() {
      console.log("Detalle requerimiento");
      let me = this;
      var Array = [];
      axios
        .post("api/DetallesRequerimientos/GetDetallesByRequerimientoPerfil", {
          idrequerimiento: me.requerimiento_id,
          idperfil: me.perfil_id
        })
        .then(function(response) {
          console.log(
            "Entra a mostrar detalle requerimiento " + response.data[0].motivo
          );
          me.detallereq_id = response.data[0].iddetallerequerimiento;
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },

    MostarDetalleRequerimiento2() {
      let me = this;
      var Array = [];
      axios
        .get("api/DetallesRequerimientos/Mostrar/" + me.detallereq_id)
        .then(function(response) {
          console.log(
            "Entra a mostrar requerimiento 2 " + response.data.motivo
          );
          (me.requerimiento_id = response.data.idrequerimiento),
            (me.perfil_id = response.data.idperfil);
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    listarDetalleRequerimiento() {
      let me = this;
      axios
        .get("api/DetallesRequerimientos/Listar")
        .then(response => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          console.log("Data Experiencia" + JSON.stringify(response.data));
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.detallereqs = res;
          console.log("Prueba" + res);
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },
    /*Postulacion */

    limpiarPostulacion() {
      postulacion_id = "";
      detallereq_id = "";
      individuo_id = "";
      trabajador_id = "";
      postulacion_fechainicio = "";
      postulacion_fechafin = "";
      postulacion_etapaactual = 1;
      postulacion_observaciones = "";
      postulacion_condicion = "";
      editedIndexpostulacion = -1;
    },

    listarPostulacion() {
      let me = this;
      axios
        .get("api/Postulaciones/Listar")
        .then(response => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          console.log("Data postulaciones" + JSON.stringify(response.data));
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.postulaciones = res;
          console.log("Prueba" + res);
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },

    editItemPostulacion(item) {
      this.postulacion_id = item.idpostulacion;
      this.detallereq_id = item.iddetallerequerimiento;
      this.individuo_id = item.idindividuo;
      this.trabajador_id = item.idempleado;
      this.postulacion_fechainicio = item.fecha_inicio;
      this.postulacion_fechafin = item.fecha_fin;
      this.postulacion_etapaactual = item.etapaactual;
      this.postulacion_observaciones = item.observaciones;
      this.postulacion_condicion = item.condicion;
      this.MostarDetalleRequerimiento2();
      this.editedIndexpostulacion = 1;
    },
    savePostulacion() {
      if (this.validar()) {
        //Este hace que no se continue
        return;
      }
      //if (this.perfilid || this.perfilid != "") {
      console.log("Llega a entrar");
      console.log(this.editedIndexpostulacion.toString());
      if (this.editedIndexpostulacion > -1) {
        let me = this;
        console.log("Actualizar");
        axios
          .put("/api/Postulaciones/Actualizar", {
            idpostulacion: me.postulacion_id,
            iddetallerequerimiento: me.detallereq_id,
            idindividuo: me.individuo_id,
            idempleado: me.trabajador_id,
            fecha_inicio: me.postulacion_fechainicio,
            fecha_fin: me.postulacion_fechafin,
            etapaactual: me.postulacion_etapaactual,
            observaciones: me.postulacion_observaciones,
            condicion: true
          })
          .then(function(response) {
            me.listarPostulacion();
            me.limpiarPostulacion();
          })
          .catch(function(error) {
            console.log(error.response);
          });
      } else {
        console.log("Crear");
        let me = this;
        axios
          .post("/api/Postulaciones/Crear", {
            iddetallerequerimiento: me.detallereq_id,
            idindividuo: me.individuo_id,
            idempleado: me.trabajador_id,
            fecha_inicio: me.postulacion_fechainicio,
            fecha_fin: me.postulacion_fechafin,
            etapaactual: 1,
            observaciones: me.postulacion_observaciones,
            condicion: true
          })
          .then(function(response) {
            me.listarPostulacion();
            me.limpiarPostulacion();
          })
          .catch(function(error) {
            console.log(error.response);
          });
      }
    },

    Imprimir() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    }
  }
};
</script>